<template>
  <v-container grid-list-sm>
    <v-layout>
      <v-flex xs12 md6 offset-sm3>
        <v-card :color="$store.state.sysBackgroundColor">
          <EncabezadoProceso
            :titulo="titulo"
            :accion="accion"
            @ejecutarAccion="ejecutarAccion"
          />
          <v-card-text>
            <v-form ref="form">
              <v-layout row wrap>
                <v-flex xs12 md8>
                  <SelectPuntoVenta
                    :model="itemActivo.Id_PuntoVenta"
                    :rules="[rules.requerido]"
                    @seleccionarItem="seleccionarPuntoVenta"
                  />
                </v-flex>
                <v-flex xs12 md2 offset-md2>
                  <v-text-field
                    label="Prefijo*"
                    v-model="itemActivo.PrefijoPuntoVenta"
                    :rules="[rules.requerido]"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex>
                  <SelectModulo
                    :model="itemActivo.Id_Modulo"
                    :rules="[rules.requerido]"
                    @seleccionarItem="seleccionarModulo"
                  />
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex>
                  <SelectTipoComprobante
                    :id_Modulo="itemActivo.Id_Modulo"
                    :model="itemActivo.Id_TipoComprobante"
                    :rules="[rules.requerido]"
                    @seleccionarItem="seleccionarTipoComprobante"
                  />
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md8>
                  <SelectTalonario
                    :id_PuntoVenta="itemActivo.Id_PuntoVenta"
                    :model="itemActivo.Id_Talonario"
                    :rules="[rules.requerido]"
                    @seleccionarItem="seleccionarTalonario"
                  />
                </v-flex>
                <v-flex xs6 md2 offset-md2>
                  <v-text-field
                    label="Letra"
                    v-model="itemActivo.Letra"
                    v-mask="'A'"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <PieCrud :loading="loading" />
        </v-card>
      </v-flex>
    </v-layout>
    <Mensaje
      :activo="mensajeActivo"
      :tipo="mensajeTipo"
      :titulo="mensajeTitulo"
      :detalle="mensajeDetalle"
      @ejecutarAccion="ejecutarAccion"
    />
  </v-container>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import { eventBus } from "@/main";
import EncabezadoProceso from "@/components/EncabezadoProceso";
import PieCrud from "@/components/PieCrud";
import Mensaje from "@/components/Mensaje";
import SelectModulo from "@/components/Sistema/SelectModulo";
import SelectTipoComprobante from "@/components/Sistema/SelectTipoComprobante";
import SelectPuntoVenta from "@/components/Sistema/SelectPuntoVenta";
import SelectTalonario from "@/components/Sistema/SelectTalonario";
export default {
  name: "ComprobanteControlarNumeracionPorTipoComprobante",
  components: {
    EncabezadoProceso,
    PieCrud,
    Mensaje,
    SelectModulo,
    SelectTipoComprobante,
    SelectPuntoVenta,
    SelectTalonario
  },
  data() {
    return {
      titulo: "Control de Numeración",
      itemVacio: {
        Id_Modulo: 0,
        NombreModulo: "",
        Id_TipoComprobante: 0,
        NombreTipoComprobante: "",
        Id_PuntoVenta: 0,
        NombrePuntoVenta: "",
        PrefijoPuntoVenta: 0,
        Id_Talonario: 0,
        NombreTalonario: "",
        Letra: "",
        Cantidad: 0
      },
      itemActivo: {},
      rules: {
        requerido: v => !!v || "Requerido"
      },
      loading: false,
      mensajeActivo: false,
      mensajeTipo: "",
      mensajeTitulo: "",
      mensajeDetalle: "",
      accion: ""
    };
  },
  created() {
    this.inicializar();
  },
  methods: {
    ejecutarAccion(accion) {
      this.accion = accion;
      switch (accion) {
        case "Ejecutar":
          if (this.$refs.form.validate()) this.buscar();
          break;
        case "AceptarConfirmacionGuardar":
          this.mostrarMensaje(false);
          this.generar();
          break;
        case "CancelarAviso":
        case "CancelarConfirmacionGuardar":
          this.mostrarMensaje(false);
          break;
        case "CancelarError":
          this.mostrarMensaje(false);
          this.ejecutarAccion("Inicializar");
          break;
        case "Inicializar":
          this.$refs.form.resetValidation();
          this.inicializar();
          break;
      }
    },
    inicializar() {
      this.itemActivo = Object.assign({}, this.itemVacio);
      setTimeout(() => {
        eventBus.$emit("setearFocoSelectPuntoVenta");
      }, 100);
    },
    seleccionarModulo(item) {
      this.itemActivo.Id_Modulo = item.Id_Modulo;
      this.itemActivo.NombreModulo = item.Nombre;
    },
    seleccionarTipoComprobante(item) {
      this.itemActivo.Id_TipoComprobante = item.Id_TipoComprobante;
      this.itemActivo.NombreTipoComprobante = item.Nombre;
    },
    seleccionarPuntoVenta(item) {
      this.itemActivo.Id_PuntoVenta = item.Id_PuntoVenta;
      this.itemActivo.NombrePuntoVenta = item.Nombre;
      this.itemActivo.PrefijoPuntoVenta = item.Prefijo;
    },
    seleccionarTalonario(item) {
      this.itemActivo.Id_Talonario = item.Id_Talonario;
      this.itemActivo.NombreTalonario = item.Nombre;
      this.itemActivo.Letra = item.Letra;
    },
    buscar() {
      if (this.itemActivo.NombreModulo == this.$nombreModulo_Venta)
        this.buscarVenta();
    },
    buscarVenta() {
      this.loading = true;
      HttpHelper.get("Venta/ControlarNumeracion", {
        nombrePuntoVenta: this.itemActivo.NombrePuntoVenta,
        id_Talonario: this.itemActivo.Id_Talonario,
        nombreTalonario:
          this.itemActivo.NombreModulo +
          " / " +
          this.itemActivo.NombreTipoComprobante +
          " / " +
          this.itemActivo.NombreTalonario,
        accion: "Controlar"
      })
        .then(response => {
          this.itemActivo.Cantidad = response.data;
          if (response.data == 0) {
            this.mostrarMensaje(
              true,
              "Aviso",
              "Felicitaciones",
              "Los comprobantes fueron generados sin errores."
            );
          } else this.imprimir();
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    imprimir() {
      if (this.itemActivo.NombreModulo == this.$nombreModulo_Venta)
        this.imprimirVenta();
    },
    imprimirVenta() {
      this.loading = true;
      HttpHelper.getBlob("Venta/ControlarNumeracion", {
        accion: "Imprimir",
        nombrePuntoVenta: this.itemActivo.NombrePuntoVenta,
        id_Talonario: this.itemActivo.Id_Talonario,
        nombreTalonario:
          this.itemActivo.NombreModulo +
          " / " +
          this.itemActivo.NombreTipoComprobante +
          " / " +
          this.itemActivo.NombreTalonario
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          let fileName = response.headers["content-disposition"]
            .split(";")[1]
            .split("=")[1]
            .trim();
          link.setAttribute("download", "Reporte_" + fileName);
          document.body.appendChild(link);
          link.click();
          this.mostrarMensaje(
            true,
            "ConfirmacionGuardar",
            "¿Quiere generar los comprobantes?",
            "Se detectaron " +
              this.itemActivo.Cantidad +
              " comprobantes faltantes que serán anulados."
          );
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    generar() {
      if (this.itemActivo.NombreModulo == this.$nombreModulo_Venta)
        this.generarVenta();
    },
    generarVenta() {
      this.loading = true;
      HttpHelper.get("Venta/ControlarNumeracion", {
        accion: "Generar",
        nombrePuntoVenta: this.itemActivo.NombrePuntoVenta,
        id_Talonario: this.itemActivo.Id_Talonario,
        nombreTalonario:
          this.itemActivo.NombreModulo +
          " / " +
          this.itemActivo.NombreTipoComprobante +
          " / " +
          this.itemActivo.NombreTalonario
      })
        .then(response => {
          if (response.data == "OK") {
            this.mostrarMensaje(
              true,
              "Aviso",
              "Listo",
              "Los comprobantes fueron generados con éxito."
            );
          }
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    mostrarError(error) {
      var detalle;
      detalle =
        error.response == undefined
          ? error
          : error.response.data.ExceptionMessage;
      this.mostrarMensaje(true, "Error", null, detalle);
    },
    mostrarMensaje(activo, tipo, titulo, detalle) {
      if (activo) {
        this.mensajeTipo = tipo;
        this.mensajeTitulo = titulo;
        this.mensajeDetalle = detalle;
      }
      this.mensajeActivo = activo;
    }
  }
};
</script>
